// utils/dateUtils.js
class DateUtils {
  static formatDate(date) {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  static parseDate(dateString) {
    if (!dateString) {
      return null;
    }

    let parts = dateString.split("-");

    let year = parseInt(parts[0]);
    let month = parseInt(parts[1]) - 1; // base 0
    let day = parseInt(parts[2]);

    return new Date(year, month, day);
  }

  static stringToDate(dateStr) {
    if (!dateStr) {
      return null;
    }

    let date;
    try {
      let dateArray = dateStr.split("-");
      date = new Date(
        parseInt(dateArray[0]),
        parseInt(dateArray[1]) - 1,
        parseInt(dateArray[2])
      );
    } catch (e) {
      console.error(e);
    }
    return date;
  }

  static dateToString(date) {
    if (!date) {
      return null;
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  static getWeekNumber(date) {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const firstDayOfMonth = startOfMonth.getDay();
    const offsetDate = date.getDate() + firstDayOfMonth - 1;
    return Math.ceil(offsetDate / 7);
  }

  static getDefaultFilters() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    const startDate = this.formatDate(new Date(year, month, 1));
    const endDate = this.formatDate(new Date(year, month + 1, 0));
    return { startDate, endDate };
  }
}

export default DateUtils;
